/*--------------------------------------------------------------------------\
    pagemanager.js

    Description
      JavaScript for the Page Manager.

    Copyrights- (C) Copyright 2007-2013 Software Consulting Services, LLC (SCS).
\--------------------------------------------------------------------------*/

var SCS_PM = 
{
  /* Constants to be used by calling functions */
  "GROUP_TYPE_NONE"    : null,

   /* Note: these three must match the field named in the Page object */
  "GROUP_TYPE_SECTION" : "sectionid",
  "GROUP_TYPE_GROUP"   : "group",
  "GROUP_TYPE_ZONE"    : "zoneid",
 
  "NUM_TYPE_NONE"      : null,
  "NUM_TYPE_ABSOLUTE"  : 1,
  "NUM_TYPE_SECTION"   : 2,
  "VIEW_TYPE_ALL"      : "all",
  "VIEW_TYPE_SECTION"  : "section",
  "VIEW_TYPE_GROUP"    : "group",
  "VIEW_TYPE_ZONE"     : "zone",
  "ZONE_TYPE_COMMON"   : "common",
  "ZONE_TYPE_ALL"      : "all",

  "PREFS_NOT_REQUESTED" : 1,  // No attempts have been made to get user preferences
  "PREFS_REQUEST_MADE"  : 2,  // An Ajax request has been sent to get the preferences
  "PREFS_REQUEST_DONE"  : 3,  // The Ajax request has returned.  We won't make another 
                              // until a new browser page reload/draw.

  /* This attempts to make drawing the pages more efficient by not 
     resizing text inside the ads and in the page footer, and by 
     not resizing the ads after they are drawn to make sure they 
     align correctly with the columns. */
  "EFFICIENCY_MODE" : true,

  /* HTML id prefixes */
  "PAGE_ID_PREFIX"   : "scs_page_",
  "BOX_ID_PREFIX"    : "scs_box_",
  "VIEW_TYPE_PREFIX" : "pm_view_type_",

  /* Attach an overlib 'msg' to node 'node' */
  "attachOverlib" : function(node, msg)
  {
    if ( !isUndefinedOrNull( msg ) && msg != "" ) 
    {
      overlibConnect(node, msg, DELAY, 500, WIDTH, 250);
    }
  },

  /*
    Combine the standard PageManager clickFunc with any onclick 
    function passed in through the WebBoxes or WebPages objects.
    Pass the return value of manager.clickFunc() as the second 
    parameter to the user specified click function, letting them
    know if we selected (true) or unselected (false)
  */
  "getCombinedClickFunc" : function(manager, obj)
  {
    return function(e) 
    { 
      var func = window[obj.manager.elements[obj.elementid].onclick];
      return func(e, obj.manager.clickFunc(e));
    };
  },

  /*
    Function to return a comparison function to pass to Array.sort()
    that will sort on the primary field pField and then on pageorder 
    for any ties and then finally on zoneid for any remaining ties.
  */
  "getPageSortFunc" : function(pField)
  {
    return function(a,b)
    {
      var c = 0;
      if(!isUndefinedOrNull(pField)) 
        {
          // Use "sectionorder" instead of "sectionid" to make sure the pages
          // on section sorts sort in the product order and not necessarily
          // in alphabetical section order.
          if ( pField == "sectionid" ) pField = "sectionorder";
          c = compare(a[pField],b[pField]);
        }
      if(c === 0) 
        { c = compare(a.pageorder,b.pageorder); }
      if(c === 0) 
        { c = compare(a.zoneid,b.zoneid); }
      return c;
    }
  },

  /*
    Simple accessor function so that we have the same format of a 
    zone object in our Page.zones array.
  */
  "getZonesObj" : function(page)
  {
    var name = (page.zonename === "" && page.zoneid == 0) ? "COMMON" : page.zonename;
    return {'id':page.zoneid,'name':name} 
  }
}

var PageManager = function(obj)
{
  bindMethods( this );
  this.init( obj );
  this.createDisplaySettingsDiv();
}

PageManager.prototype = 
{
  /* Working Objects stored here during processing */
  "W_OBJS" : 
  {
    "VIEW_TYPE_SEL_1" : null,  // 1st select box in the Display Setting right hand div
    "VIEW_TYPE_SEL_2" : null,  // 2nd select box in the Display Setting right hand div
    "RIGHT_EDIT_CELL" : null,  // The right hand side of the display setting div
    "VIEW_PAGES_BY"   : null,  // Caches the PageManager.viewPagesBy value during active 
                               // editing in the Display Settings Div, then sets only 
                               // if the user clicks Update
    "PREFTYPES_SEL"   : null   // The select box for the user preferences
  },

  /* Object to store the PagMod Colors and their HTML equivalents.
     Stored inside PageManager so we can have two PageManagers on 
     one page with differing colors */
  "PagModColors": {  "01": "black",
                     "02": "blue",
                     "03": "rgb(162,255,162)", // Dark Green 
                     "04": "#00ffff", // Cyan
                     "05": "rgb(255,162,164)", // Red
                     "06": "#ff00ff", // Magenta
                     "07": "#a52a2a", // Brown
                     "08": "#d3d3d3", // Light Gray
                     "09": "#aaaaaa", // Dim Gray
                     "10": "#add8e6", // Light Blue
                     "11": "#ccff66", // Instead of CSS's green - matches PagMod
                     "12": "#dda0dd", // Plum
                     "13": "#ffc0cb", // Pink
                     "14": "#ffa500", // Orange
                     "15": "rgb(255,255,161)", // Yellow
                     "16": "white"     
  },
  
  /* Object to link named constants to the PagMod color codes.
     Stored inside PageManager so we can have two PageManagers on 
     one page with differing colors */
  "PagModColorNames" : { "BLACK"     : "01",
                         "BLUE"      : "02",               
                         "DARKGREEN" : "03",
                         "CYAN"      : "04",
                         "RED"       : "05",
                         "MAGENTA"   : "06",
                         "BROWN"     : "07",
                         "LIGHTGREY" : "08",
                         "DIMGREY"   : "09",
                         "LIGHTBLUE" : "10",
                         "GREEN"     : "11",
                         "PLUM"      : "12",
                         "PINK"      : "13",
                         "ORANGE"    : "14",
                         "YELLOW"    : "15",
                         "WHITE"     : "16" },

  /*
    Accepts an element object and returns an object with the colors 
    for that element. 
  
    Looks in the following orders:

     - cssboxcolor/cssfontcolor     (specified in WebBoxTable)
     - rendfilename                 (specified in PagModElementsTable)

    Should also be updated when needed to use the PagModContexts table
  */
  "getColorObj" : function(e)
  {
    var retObj = { 'box' :       "gray",
                   'border' :    "black",
                   'text' :      "black",
                   'selbox' :    "gray",
                   'selborder' : "black",
                   'seltext' :   "black" };

    var str = e.rendfilename;

    var _self = this;
    var getColor = function(s)
    { 
      return (isUndefinedOrNull(_self.PagModColors[s]) ? 
              "gray" : _self.PagModColors[s]); 
    };

    if((!isUndefinedOrNull(e.cssboxcolor)) && (e.cssboxcolor.length==2))
    {
      retObj.box = getColor( e.cssboxcolor );
      retObj.selbox = getColor( e.cssboxcolor );
    }
    else if(!isUndefinedOrNull(e.cssboxcolor) && strip(e.cssboxcolor) !== "")
    {
      retObj.box = e.cssboxcolor;
      retObj.selbox = e.cssboxcolor;
    }
    else if(!isUndefinedOrNull(str) && str.length >= 12)
    {
      retObj.box = getColor(str.substring(0,2));
      retObj.selbox = getColor(str.substring(6,8));
    }

    if((!isUndefinedOrNull(e.cssfontcolor)) && (e.cssfontcolor.length==2))
    {
      retObj.text = getColor( e.cssfontcolor );
      retObj.seltext = getColor( e.cssfontcolor );
    }
    else if(!isUndefinedOrNull(e.cssfontcolor) && strip(e.cssfontcolor) !== "")
    {
      retObj.text = e.cssfontcolor;
      retObj.seltext = e.cssfontcolor;
    }
    else if(!isUndefinedOrNull(str) && str.length >= 12)
    {
      retObj.text = getColor(str.substring(4,6));
      retObj.seltext = getColor(str.substring(10,12));
    }

    return retObj;
  },

  /* Return an object with the current PageManager settings, useful for 
     when you need to create a new pagemanager for a new search, but 
     want the users appearance to remain the same.  You can use the 
     object returned from this as the input to your new PageManager */
  "preserveSettings" : function(obj)
  {
    var SAVEABLE_SETTINGS = 
      [ "pagesPerRow",
        "itemsPerPage",
        "groupPagesBy",
        "viewPagesBy",
        "viewPagesFilter",
        "pageNumType",
        "showImages",
        "zoneType",
        "noWrap" ];

    if(isUndefinedOrNull(obj)) { obj = {}; }
    var _self = this;
    forEach(SAVEABLE_SETTINGS, function(s)
    {
      if(typeof _self[s] !== "undefined")
        { obj[s] = _self[s]; }
    });
    return obj;
  },

  /* Initialize the PageManager, including settings from 'obj' and 
     reading in all the pages,boxes,elements data */
  "init" : function(obj)
  {
    var n = isUndefinedOrNull; // Quick alias
    if(n(obj) || n(obj.pages) || n(obj.frame) || n(obj.id) || obj.id.length > 8)
    {
      scs_err("Invalid initialization data specified for PageManager.");
    }
    else
    {
      this.pages = [];
      this.boxes = [];
      this.sections = [];
      this.zones = [];
      this.groups = [];
      this.elements = [];
      this.overrideColors = {};
      this.adTypes = { 'displayad' : { 'label':getLangString("AD"),     'color':null},
                       'edblock'   : { 'label':getLangString("EDBLOCK"),'color':null},
                       'adblock'   : { 'label':getLangString("ADBLOCK"),'color':null},
                       'holdad'    : { 'label':getLangString("ONHOLD"), 'color':null},
                       'filler'    : { 'label':getLangString("FILLER"), 'color':null} };

      /* This object stores all of the default settings for the PageManager, 
         and also represents the valid settings that can be passed to the 
         PageManager constructor.  Values preceded with an underscore are
         private to the pageManager and should not be passed in. */
      var defaultObj = { /* What Id should the pageManager have.  This is required, 
                            and should be 8 characters or less */
                         'id'              : null,

                         /* HTML element to draw the pages in */
                         'frame'           : null,

                         /* How many pages across */
                         'pagesPerRow'     : 5,
        
                        /* A function for after redrawing the pages per row */
                         'pagesPerRowCallback': null,
 
                         /* What Page are we displaying (Page 1 = Items 1 through n, Page 2 = Items n+1 through 2n) */
                         'currentPage'     : 1,

                         /* How should we group pages?  Section?  Group?  Zone? */
                         'groupPagesBy'    : SCS_PM.GROUP_TYPE_NONE,

                         /* View common zones (and first zaone for zoned pages) or all zones for all pages? */
                         'zoneType'        : SCS_PM.ZONE_TYPE_COMMON,

                         /* What do we want to view by? */
                         'viewPagesBy'     : SCS_PM.VIEW_TYPE_ALL, 

                         /* If we are viewing by section/group/zone, which section/group/zone are we looking at? */
                         'viewPagesFilter' : "All",

                         /* And how many items should be on each page? Items can be either pages, sections, groups, or zones */
                         'itemsPerPage'    : 50,

                         /* Absolute or sectino page numbering? */
                         'pageNumType'     : SCS_PM.NUM_TYPE_ABSOLUTE,

                         /* Should we show ad images if we have them?  Stored in Element.imagesrc */
                         'showImages'      : false,

                         /* Stores the currently selected box (HTML Element Node) */
                         'selectedBox'     : null,

                         /* Default menu icons.  More can be added using PageManager.addMenuIcon() */
                         'menuIcons'       : [ { 'icon' : 'MAGGLASS',
                                                'msg'  : "Page View Options",
                                                'func' : this.editDisplaySettings,
                                                'avail' : null } ],

                          /* Remove the printer icon until the pdf creation
                             gets fixed.
                            { 'icon' : 'PRINTER',
                              'msg'  : getLangString("GENERATEPDF"),
                              'func' : this.generatePDF },
                           */    
                         
                         /* PrefItems - Different, application-specific weays to save preferences:
                              For example, Track may save by PageType or PubEd, while Reservation 
                              may save by PubEd only.  The default, which is included, is by 
                              application.  The Id should be no longer than 12 characters, and the 
                              description is what will appear to the user in the dropdown box when 
                              saving preferences.  */
                         'prefItems'        : [ { 'id'       : '_default',
                                                  'desc'     : 'By Application',
                                                  'priority' : 0 } ],

                         /* We lock while we generate the PDF to avoid multiple requests */
                         '_pdf_lock'        : false,
        
                         /* Lock if user is editing page settings. */
                         '_draw_lock'       : false,
                         'noWrap'           : false,

                         /* We keep track of whether we have already gotten user preferences or not */
                         '_getPrefState'    : SCS_PM.PREFS_NOT_REQUESTED,
                         '_getPrefDeferred' : null,

                         /* Whether we use a progress bar to draw or not */
                         '_progBar' : false,
        
                         /* Should not be set by the user, stores the current PagMod to Pixel ratio */
                         '_pmToPx'         : {'last':0,'width':0},

                         /* Stores the average number of columns drawn so far...used for a simple 
                            guess of whether we have found a super page or not */
                         '_avgNumColumns'  : {'sum':0,'avg':0} };
      
      /*
        Go through the object passed in and copy all of the 
        PagMod structures into local structures here.
      */

      // Must do this here, the legend colors are set during 
      // the following loops
      if(!n(obj.overrideColors))
      {
        this.initOverrideColors(obj);
        delete(obj.overrideColors);
      }

      if(!n(obj.pages))
      {
        this.initPages(obj);
        delete(obj.pages);
        delete(obj.webPages);
      }

      if(!n(obj.boxes))
      {
        this.initBoxes(obj);
        delete(obj.boxes);
      }

      if(!n(obj.elements))
      {
        this.initElements(obj);
        delete(obj.elements);
        delete(obj.webBoxes);
      }

      setdefault(this, obj);
      setdefault(this, defaultObj);

      // We want to always reset current page if init is called.
      this.currentPage = 1;
      
      /* We cannot call this here because it needs to know what 
         additional types of preferences to look for, and doesnt 
         know that until all calls to addPrefItem() have been made
         so we know what the other types are */
      //this.getPrefs();
    }
  },

  /* Set any user specified color overrides */
  "initOverrideColors" : function(obj)
  {
    var n = isUndefinedOrNull;
    if(!n(obj.overrideColors))
    {
      for(var i in obj.overrideColors)
      {
        var index = this.PagModColorNames[i];
        if(!n(index) && !n(this.PagModColors[index]))
          { this.PagModColors[index] = obj.overrideColors[i]; }
      }
    }
    return true;
  },

  /* Transfer data from obj.pages to PageManager.pages */
  "initPages" : function(obj)
  {
    var n = isUndefinedOrNull;
    var _self = this; // MochiKit's forEach uses a 'self' variable...

    // Order the pages by absolute page number first.
    var orderPagesFunc = function( a, b ) {
      return compare( a.pagenum, b.pagenum );
    }
    obj.pages.sort( orderPagesFunc );

    // Create a new sectionorder value, this replaced sectionid when sorting.
    // This is important because alphabetical order does not necessarily match
    // the order in which the section appear in the publication.
    var counter = -1;
    for ( var i = 0 ; i < obj.pages.length ; i++ ) {
      if ( _self.sections.indexOf( obj.pages[i].sectionid ) < 0 ) {
      	counter++;
        _self.sections.push( obj.pages[i].sectionid );
        obj.pages.sectionorder = counter;
      } else {
      	obj.pages.sectionorder = counter;
      }
    }

    // We need to generate a section page number...
    obj.pages.sort(SCS_PM.getPageSortFunc("sectionid"));
    
    var secNum = 1;
    for(var i = 0; i < obj.pages.length; i++)
    { 
      var p = obj.pages[i];

      // Set labels for ungrouped and unsectioned pages
      if(strip(p.sectionid) === "") { p.sectionid = "No Section"; }
      if(strip(p.group) === "") { p.group = "No Group"; }

      // Restart numbering when we find a new section, 
      if(i > 0 && p.sectionid !== obj.pages[i-1].sectionid)
       { secNum = 1; }
      // But dont increase if we found the same pageid, which means we 
      // are just another zoned version of the same page
      else if(i > 0 && p.pageid !== obj.pages[i-1].pageid)
       { secNum++; }

      // Set the section page number
      p.sectionpagenum = secNum;

      var page = _self.newPage(p);

      if (!n(obj.webPages))
      {
        forEach(obj.webPages, function(wp)
        {
          if( wp.pageid === page.pageid && 
              wp.pubid === page.pubid &&  
              wp.issueid === page.issueid &&  
              wp.zoneid === page.zoneid  )
          {
            // Assign all properties on the webPage to the Page.  
            //  - "T" -> true 
            //  - "F" -> false
            //  - Otherwise, set it to whatever it is
            for(var i in wp)
            {
              if(!n(wp[i]))
              {
                if ( typeof wp[i] == "string" ) {
                  page[i] = ( wp[i] === "T" ? 
                              true : 
                              ( wp[i] === "F" ? 
                                false : 
                                strip(wp[i]) ) );
                }
                else {
                  page[i] = wp[i];
                }                  
              }
            }
          }
        });
      }

      // Append to zones/groups arrays if needed.
      // Section list is built in a different order outside this loop.
      if ( objIndexOf( _self.zones, "id", page.zoneid ) < 0 )
        { _self.zones.push(SCS_PM.getZonesObj(page)); }

      if( _self.groups.indexOf( page.group ) < 0 )
        { _self.groups.push(page.group); }


      // Add the page to the PageManager
      if(n(_self.pages[page.pageid]))
      {
        _self.pages[page.pageid] = page;

        // Since this is the first occurence, assume we arent zoned, 
        // and create the array with this zone
        _self.pages[page.pageid].iszoned = false;
        _self.pages[page.pageid].zones = [ page.zoneid ];
      }
      else
      {
        // Now that we found a second zone, set our iszoned flag and 
        // just append that zone to the array
        _self.pages[page.pageid].iszoned = true;
        _self.pages[page.pageid].zones.push( page.zoneid );
      }
    }

    // Sort two PageManager arrays - zones/groups.
    // The section list appears in the order it appears in the publication.
    _self.zones.sort(getFieldCmpFunc("id"));
    _self.groups.sort();

    // Add an "All" to the beginning of each
    _self.sections.unshift("All");
    _self.zones.unshift({'id':"All",'name':'All'});
    _self.groups.unshift("All");

    return true;
  },

  /* Transfer data from obj.boxes to PageManager.boxes */
  "initBoxes" : function(obj)
  {
    var n = isUndefinedOrNull;
    var _self = this;

    /* Comparison function for sorting the boxes */
    function sortBoxesFunc(a,b)
    {
      c = compare(a.pageid, b.pageid);
      if (c == 0) {
        c = ((a.posy == null)? -1: a.posy) - ((b.posy == null)? -1: b.posy);
      }
      return c;
    };

    if(!n(obj.boxes))
    {
      /* sort the obj boxes */
      obj.boxes.sort(sortBoxesFunc);

      /* copy the obj boxes to pagemanager boxes */
      forEach(obj.boxes, function(b)
      { 
        var box = _self.newBox(b);
        if(isUndefinedOrNull(b.boxnum)) { b.boxnum = new Date().getTime(); }
        var boxNum = parseInt( b.boxnum, 10 );
        _self.boxes[boxNum] = box;
      });
    }

    return true;
  },
 
  /* Transfer data from obj.elements to PageManager.elements */
  "initElements" : function(obj)
  {
    var n = isUndefinedOrNull;
    var _self = this;
    if(!n(obj.elements))
    {
      forEach(obj.elements, function(e)
      { 
        if(n(e.elementid) || trim(e.elementid) == "")
          { scs_err("Invalid element data specified in PageManager constructor"); }
        _self.elements[e.elementid] = e;
        if (!n(obj.webBoxes))
        {
          var _e = e;
          forEach(obj.webBoxes, function(wb)
          {
            if (wb.elementid == _e.elementid)
            {
              // Assign all properties on the webBox to the element.  
              //  - "T" -> true 
              //  - "F" -> false
              //  - Otherwise, set it to whatever it is
              for(var i in wb)
              {
                if(!n(wb[i]))
                {
                  _self.elements[_e.elementid][i] = ( wb[i] === "T" ? 
                                                      true : 
                                                      ( wb[i] === "F" ? 
                                                        false : 
                                                        strip(wb[i]) ) );
                }
              }
            }
          });

          // Convert numstrings to numbers
          if(!isUndefinedOrNull(e.widthcols) && e.widthcols !== "") { e.widthcols = parseInt(e.widthcols,10); }
          if(!isUndefinedOrNull(e.posxcols)  && e.posxcols  !== "") { e.posxcols  = parseInt(e.posxcols,10); }
        }

        // Set the PageManager colors to external routines and update 
        // their legends if need be
        var label = "";

        if(!n(e.keylabel) && strip(e.keylabel) !== "")
          { label = e.keylabel; }
        else if(e.elemtype === "HOLDAD")
          { label = "holdad"; }
        else if(e.elemtype == "ED_BLOCK")
          { label = "edblock"; }
        else if(e.elemtype == "RESADBLOCK")
        {
          if ( e.blocktype == "AD" || e.blocktype == "HO" )
            { label = "adblock"; }
          else if ( e.blocktype == "ED" )
            { label = "edblock"; }
        }
        else if(e.elemtype == "RESADBOX")
          { label = "displayad"; }
        else if(e.elemtype == "FILLER")
          { label = "filler"; }

        if(label != "" && n(_self.adTypes[label]))
          { _self.adTypes[label] = {'label':getLangString(label), 'color' : null}; }

        if(label != "" && n(_self.adTypes[label].color))
          { _self.adTypes[label].color = _self.getColorObj(e).box; }

      });
    }
    return true;
  },


  /****************************************************************
   * Generic accessor functions to be called by external routines
   ****************************************************************/
  
  /*
    Generate a PDF view of the pages printed.  This requires that
    this.printCommand is set to a command in the current 
    application area that will take the most recent PagMod tables
    used to generate the most recent view, and pass them to the
    pm2outext wrapper function.  The PerformFunc for 
    this.printCommand must return XML, and include a node <File>
    with the path of the resulting PDF file.  This should reside 
    in $WEB_SCRATCH as a getfile command will the be used to 
    retreive the file.
  */
  "generatePDF" : function()
  {
    if(this._pdf_lock) { return false; }
    if(!isUndefinedOrNull(this.printCommand))
    {
      this._pdf_lock = true;
      var _self = this;
      var myCallback = function(lrm)
      {
        var keys = [ "command", 
                     "filename", "t" ];
        var vals = [ "getfile", 
                     lrm.getOther("File"), new Date().getTime() ];
        var url = "spice.pl/" + "pgl.pdf?" + queryString(keys,vals);
        _self._pdf_lock = false;
        window.open(url);
      };
  
      var myErrback = function(lrm)
      {
        _self._pdf_lock = false;
        defaultErrorCallback(lrm);
      }
  
      var keys = [ "pagesperrow" ];
      var vals = [ this.pagesPerRow ];

      genericAjaxRequest(this.printCommand, false, myCallback, myErrback, keys, vals);
    }
  },
  
  /**
   * Create the div used for editing display settings.  This function only
   * needs to be called once from the constructor.
   */
  "createDisplaySettingsDiv": function() {
    var _self = this;
    var rootNode = DIV();
    appendChildNodes( rootNode,
                      DIV( { 'class': 'scs_b scs_u' },
                         "Choose which view type you would like:" ) );
    var tbl = TABLE();
    var tbody = TBODY();
    var tr = TR();
    var tdl = TD( { 'style': 'padding-right:25px' } ); 
    var tdr = TD( { 'style': 'vertical-align:top;' } );

    /* Quick function to retrive and radio button and label 
       for the given value and label */
    var getInputAndLabel = function( pm, val, lbl ) {
      var i  = INPUT( { 'type'   : 'radio',
                        'name'   : SCS_PM.VIEW_TYPE_PREFIX,
                        'id'     : SCS_PM.VIEW_TYPE_PREFIX + val,
                        'value'  : val } );
      var l =  LABEL( { 'class'  : 'scs_b',
                        'for'    : SCS_PM.VIEW_TYPE_PREFIX + val },
                      lbl );

      if ( pm.viewPagesBy === val ) {
        setNodeAttribute( i, "checked", "checked" );
        i.checked = true;
      }
       
      connect( i, "onclick", pm.updateEditDiv );
 
      return [i,l];
    }
    
    // Generate the radio buttons and labels for the different options
    var tmpArr = getInputAndLabel( this, SCS_PM.VIEW_TYPE_ALL,
                                   "View all pages" );
    appendChildNodes( tdl, tmpArr.shift(), tmpArr.shift(), BR(), BR() );
    
    tmpArr = getInputAndLabel( this, SCS_PM.VIEW_TYPE_SECTION,
                               "View by Section" );
    appendChildNodes( tdl, tmpArr.shift(), tmpArr.shift(), BR(), BR() );
    
    tmpArr = getInputAndLabel( this, SCS_PM.VIEW_TYPE_GROUP, "View by Group" );
    appendChildNodes( tdl, tmpArr.shift(), tmpArr.shift(), BR(), BR() );
      
    tmpArr = getInputAndLabel( this, SCS_PM.VIEW_TYPE_ZONE, "View by Zone" );
    appendChildNodes( tdl, tmpArr.shift(), tmpArr.shift(), BR(), BR() );
      
    // No-wrapping option
    this.W_OBJS.VIEW_NOWRAP = INPUT({'type':'checkbox', 'id':'noWrap', 'value':'true'});
    var tr2 = TR(null, TD(null, this.W_OBJS.VIEW_NOWRAP, "Do Not Wrap"));

    // Save selection
    var saveSel = SELECT();
    forEach( this.prefItems, function( p ) {
               appendChildNodes( saveSel, OPTION( { "value": p.id },
                                                  p.desc ) );
             } );
    this.W_OBJS.PREFTYPES_SEL = saveSel;


    var tr3 = TR( null, TD( { "class": "scs_right" }, "Save Options" ), TD( null, saveSel ) );
    
    // Cache this for later...
    this.W_OBJS.RIGHT_EDIT_CELL = tdr;

    appendChildNodes( tr, tdl, tdr );
    appendChildNodes( tbody, tr );
    appendChildNodes( tbody, tr2 );
    appendChildNodes( tbody, tr3 );
    appendChildNodes( tbl, tbody );
    appendChildNodes( rootNode, tbl );

    var cancelFunc = function() { _self._draw_lock = false; }

    var updateButton = { "key": "update",
                         "caption": getLangString( "UPDATE" ),
                         "func": this.updateDisplaySettings,
                         "isDefault": false,
                         "isCancel": false };

    appendChildNodes( currentDocument().body, rootNode );
    this.displaySettingsFloatingDiv = new FloatingDiv( rootNode,
                                                       { "title": "Page View Options",
                                                         "saveFunc": this.savePrefs,
                                                         "cancelFunc": cancelFunc,
                                                         "additionalButtons": [ updateButton ] } );
  },

  /*
    editDisplaySettings is a function that will open up a floating div
    and allow the user choose the various display criteria and filters 
    for the pages they are looking at.  This includes:
     - Pages per line
     - One of the following:
       - Pages per page (when sections/groups are not used)
       - Specific sections (A,B,C, ALL)
         - Number of sections to display per page (only when ALL is selected)
       - Specific groups (MAIN,SPORTS,ALL)
         - Number of groups to display per page (only when ALL is selected)
       - Specific zones
         - Number of zones to display per page (only when ALL is selected)
  */ 
  "editDisplaySettings" : function()
  {
    this._draw_lock = true;
    this.W_OBJS.VIEW_PAGES_BY = this.viewPagesBy;
    
    /* Do a redraw of the right div before entering by signaling the onlick. */
    var radioButton = $( SCS_PM.VIEW_TYPE_PREFIX + this.viewPagesBy );
    signal( radioButton, "onclick" );
    setNodeAttribute( radioButton, "checked", "checked" );
    radioButton.checked = true;

    this.W_OBJS.VIEW_NOWRAP.checked = this.noWrap;
    
    this.displaySettingsFloatingDiv.show();
  },

  /* Return the right hand dside of the Display Settings box based 
     on the current value in this.W_OBJS.VIEW_PAGES_BY */
  "getRightHandEditDiv" : function()
  {
    var div = DIV({'style':'padding: 10px;background-color: #ddd;border: 1px dashed #666;'});

    switch(this.W_OBJS.VIEW_PAGES_BY)
    { 

      // When viewing All Pages, we just need a SELECT box for the number 
      // of pages to display per page
      case SCS_PM.VIEW_TYPE_ALL:

        var pppSel = SELECT({ 'id' : this._pppSelId, 'style':'margin-top:5px;' }, null);
        setStyle(pppSel, {'margin-left':'15px'});

        var _self = this;
        forEach([25,50,75], function(n)
        {
          var opt = OPTION({'value':n}, n);
          if(n === _self.itemsPerPage) { setNodeAttribute(opt, 'selected', 'selected'); }
          appendChildNodes(pppSel, opt);
        });
 
        appendChildNodes(div, SPAN("# pages to display: "), BR(), pppSel);
 
        this.W_OBJS.VIEW_TYPE_SEL_1 = pppSel;
        break;


      // Otherwise we need to potentially two select boxes, which we get 
      // from getSectionGroupRightHandDiv
      case SCS_PM.VIEW_TYPE_SECTION:
   
        var obj = this.getSectionGroupRightHandDiv(this.sections, 
                                                   "Section(s) to Display", 
                                                   "# of sections to display per page");
        appendChildNodes(div, obj.shift(), BR(), obj.shift());
        break;

      case SCS_PM.VIEW_TYPE_ZONE:
        
        var obj = this.getSectionGroupRightHandDiv(this.zones, 
                                                   "Zone(s) to Display", 
                                                   "# of zones to display per page");
        appendChildNodes(div, obj.shift(), BR(), obj.shift());
        break;

      case SCS_PM.VIEW_TYPE_GROUP:
   
        var obj = this.getSectionGroupRightHandDiv(this.groups, 
                                                   "Group(s) to Display", 
                                                   "# of groups to display per page");
        appendChildNodes(div, obj.shift(), BR(), obj.shift());
        break;

      default:

        throw("Invalid view type specified.");


    }

    return div;
  },

  "getSectionGroupRightHandDiv" : function(arr, q1, q2)
  {
    var retArr = [];

    /* First, let the user choose which section to display */
    var sel1 = SELECT({'style':'margin-top:5px;'});
    setStyle(sel1, {'margin-left':'15px'});

    var _self = this;
    forEach(arr, function(n)
    {
      var val = (n.id)   ? n.id : n;
      var txt = (n.name) ? n.name : val;
      var opt = OPTION({'value':val}, txt);
      if(val === _self.viewPagesFilter) { setNodeAttribute(opt, 'selected', 'selected'); }
      appendChildNodes(sel1, opt);
    });
 
    sel1.onchange = this.hideSecondEditSel;

    retArr.push( DIV(null, SPAN(q1 + ": "), BR(), sel1 ) );
 
    this.W_OBJS.VIEW_TYPE_SEL_1 = sel1;


    // Now, create the dropdown for how many items to show per page
    var sel2 = SELECT({'style':'margin-top:5px;'});
    setStyle(sel2, {'margin-left':'15px'});

    var selArr;
    if(this.W_OBJS.VIEW_PAGES_BY === SCS_PM.VIEW_TYPE_GROUP)
      { selArr = [1,2,3,4,5,6,7,8,9,10]; }
    else
      { selArr = ['All',1,2,3,4,5]; }

    forEach(selArr, function(n)
    {
      var opt = OPTION({'value':n}, n);
      if(n === _self.itemsPerPage && _self.W_OBJS.VIEW_PAGES_BY === this.viewPagesBy) 
        { setNodeAttribute(opt, 'selected', 'selected'); }
      appendChildNodes(sel2, opt);
    });
 
    retArr.push( DIV(null, SPAN(q2 + ": "), BR(), sel2) );

    this.W_OBJS.VIEW_TYPE_SEL_2 = sel2;
    this.hideSecondEditSel();

    return retArr;
  },
  
  /* If the user has chosen "All" in the first select, then we 
     need to show the second select, otherwise we hide the second 
     select. */
  "hideSecondEditSel" : function()
  {
    if(this.W_OBJS.VIEW_TYPE_SEL_1.value === "All")
    {
      removeElementClass(this.W_OBJS.VIEW_TYPE_SEL_2.parentNode, "scs_hidden");
    }
    else
    {
      addElementClass(this.W_OBJS.VIEW_TYPE_SEL_2.parentNode, "scs_hidden");
    }
    return true;
  },

  /* Called when the user saves the new display settings.  
     Updates internal variables and redraws the pages */
  "updateDisplaySettings" : function(redraw)
  {
    if(isUndefinedOrNull(redraw)) { redraw = true; }

    nd(); // Close the overlib if still open

    this.viewPagesBy = this.W_OBJS.VIEW_PAGES_BY;
    switch(this.viewPagesBy)
    {
      case SCS_PM.VIEW_TYPE_ALL:

        var val1 = this.W_OBJS.VIEW_TYPE_SEL_1.value;
        this.setItemsPerPage(val1);
        break;

      case SCS_PM.VIEW_TYPE_SECTION:
      case SCS_PM.VIEW_TYPE_ZONE:
      case SCS_PM.VIEW_TYPE_GROUP:

        var val1 = this.W_OBJS.VIEW_TYPE_SEL_1.value;
        this.viewPagesFilter = val1;
        if(val1 === "All")
        {
          var val2 = this.W_OBJS.VIEW_TYPE_SEL_2.value;
          if (val2 == 'All') {
            var items = 1;
            if(this.viewPagesBy === SCS_PM.VIEW_TYPE_SECTION)
              { items = this.sections.length; }
            else if(this.viewPagesBy === SCS_PM.VIEW_TYPE_ZONE)
              { items = this.zones.length; }
            else if(this.viewPagesBy === SCS_PM.VIEW_TYPE_GROUP)
              { items = this.groups.length; }

            this.setItemsPerPage(items);
          } else {
            this.setItemsPerPage(val2);
          }
        }
        break;
        
      default:

        throw("Invalid view type specified.");
    }
   
    // Hide and restore the content
    this.displaySettingsFloatingDiv.hide();
    this.currentPage = 1;
    this._draw_lock = false;
    this.noWrap = this.W_OBJS.VIEW_NOWRAP.checked;
    
    if(redraw) { this.draw(); }
    
    return true;
  },

  /* Called when the user chooses a new radio button, and updates 
     the right hand side */
  "updateEditDiv" : function(e)
  {
    var input = e.src();
    var type = getNodeAttribute(input, "value");
    //if(this.W_OBJS.VIEW_PAGES_BY !== type) { this.itemsPerPage = 1; }
    this.W_OBJS.VIEW_PAGES_BY = type;
    replaceChildNodes(this.W_OBJS.RIGHT_EDIT_CELL, this.getRightHandEditDiv());
    return true;
  },

  /*
    Return the color used for the type 't'

    't' is ether "displayad", "holdad", "adblock", "edblock", or "filler"
  */
  "getColor" : function(t)
  
  {
    var n = isUndefinedOrNull;
    if(n(this.adTypes[t])) { return null; }
    else { return this.adTypes[t].color; }
  },
  
  /* Return the boxnum of an element that contains the given string
        in it's descriptive text */
  "getBoxNumFromDescText" : function(descText)
  {
    boxNum = 0;
    for(var n in this.elements) {
      element = this.elements[n];
      if( isUndefinedOrNull(element) ) { continue; }
      for(var i=1; i<=10; i++) {
        text = element["desctext" + i];
        if(text == "") { break; }
        if(text.indexOf(descText) == -1) { continue; }
        boxNum = n;
      }
      if(boxNum != 0) { break; }
    }
    return boxNum;
  },

  /* Return the PageManager.boxes object for 'boxnum' */
  "getBoxObject" : function(boxnum)
  {
    return this.boxes[boxnum];
  },

  /* Return the drawn HTML element for the box given by boxnum */
  "getBoxElement" : function(boxnum)
  {
    return $(this.getBoxObject(boxnum).getId());
  },

  /* Scroll the window to 50px above the given box object */
  "scrollToBox" : function(box)
  {   
    var n = isUndefinedOrNull;
    if(n(box)) { return false; }

    var boxElem = $(box.getId());
    this.unselectBox();

    if(!n(boxElem) && this.selectBox(boxElem))
    {
      $j( 'html, body' ).animate( { "scrollTop": $j(boxElem).offset().top }, 2000 );
    }
  },

  /****************************************************************
   * Generic accessor functions needed by different objects
   ****************************************************************/
  "getPageId" : function(page)
  { 
    return SCS_PM.PAGE_ID_PREFIX + page.pageid;
  },

  /*
    Given an HTML element on the page, return the Box or Page 
    object it corresponds to
  */
  "getObject" : function(elem)
  {
    var id = getNodeAttribute(elem, "id");
    if(id.indexOf(SCS_PM.PAGE_ID_PREFIX) >= 0)
    {
      return this.pages[id.substring(SCS_PM.PAGE_ID_PREFIX.length)];
    }
    else if(id.indexOf(SCS_PM.BOX_ID_PREFIX) >= 0)
    {
      return this.boxes[id.substring(SCS_PM.BOX_ID_PREFIX.length)];
    }
    
    return null;
  },

  "getFrame" : function()
  {
    return this.frame;
  },
  
  "getFrameWidth" : function()
  {
    return this.frame.offsetWidth - 4 - 1 - 6;  // 4 accounts for borders
                                                // 1 accounts for rounding issues
                                                // 6 accounts for some sort of issue in Chrome.  
                                                //   without the -6, chrome sometimes drops a 
                                                //   page down the the next row.
  },
 
  /* Update the number of items per page in the pagemanager */
  "setItemsPerPage" : function(n)
  {
    if(isUndefinedOrNull(n))
      { scs_err("Invalid number of items per page specified."); }
    else
    { 
      try{ this.itemsPerPage = parseInt(n,10); }
      catch( e ) { scs_err("Invalid number of items per page specified."); return false; }
    }
    return true;
  },
 
  "newPage" : function(obj)
  {
    return new Page(obj, this);
  },

  "newBox" : function(obj)
  {
    return new Box(obj, this);
  },

  /*
    Attach a click event to the Box or Page object if appropriate.
  */
  "attachClickEvent" : function(node, obj)
  {
    var n = isUndefinedOrNull;
    if(!n(obj.boxnum))
    {
      // We have a Box element
      var func = null;
      if(!n(obj.manager.elements[obj.elementid]) &&
         !n(obj.manager.elements[obj.elementid].onclick) &&
         typeof window[obj.manager.elements[obj.elementid].onclick] )
        { func = SCS_PM.getCombinedClickFunc(this,obj); }
      else
        { func = this.clickFunc; }
      disconnectAll( node, "onclick" );
      connect(node, "onclick", func);
      addElementClass(node, "clickable");
    }
    else
    {
      // We have a Page element...no click events for these now
    }
  },
 
  /*
    Function to execute when an object is clicked on.  Currently 
    only supports clicking on Box elements.  The PageManager object
    stores locally a selectedBox which is the HTML node for the 
    selected box.  If we click on the selected box, we unselect it 
    and return false, otherwise, we unselect any other box previously 
    selected, select the box we clicked on, and return true.
  */
  "clickFunc" : function(e)
  {
    return this.selectBox(e.src());
  },

  /* Unselect any box currently selected */
  "unselectBox" : function()
  {
    if(!isUndefinedOrNull(this.selectedBox))
    {
      // We already have a box selected somewhere, unselect it
      removeElementClass(this.selectedBox, "selected");
      setStyle(this.selectedBox, { 'border-color' : '' });
      this.selectedBox = null; 
      return true;
    }
    return false;
  },

  /* Select the box given by the HTML element 'boxElem' */
  "selectBox" : function(boxElem)
  {
    var n = isUndefinedOrNull;
    var a = getNodeAttribute;
    if(!n(this.selectedBox)) 
    { 
      var isMe = a(this.selectedBox, "id") === a(boxElem, "id");

      this.unselectBox();

      // If we unselected ourself, then lets exit
      if(isMe) { return false;}
    }
    this.selectedBox = boxElem;
    addElementClass(boxElem, "selected");
    
    /* This next section is just in case we have selected a box 
       that is red, which means the border won't stand out.  In   
       this case, we update the border to be yellow */
    var obj = this.getObject(boxElem); // Get the object for this HTML element
    if(!n(obj))
    {
      var eId = obj.elementid;
      var elems = obj.manager.elements;
      if(!n(elems[eId]))
      {
        var colorObj = obj.manager.getColorObj(elems[eId]);
        if( colorObj.box === "red" || 
            colorObj.box.toLowerCase() === "#ff0000" || 
            colorObj.box.toLowerCase() === "#f00" )
        {
          // This box is already red, we need to make the selected border yellow...
          setStyle(boxElem, { 'border-color' : 'yellow' });
        }
      }
    }
    return true;
  },

  /* Total number of pages.  Only counts zoned pages once */
  "getTotalNumberOfPages" : function()
  {
    var num = 0;
    for(var i in this.pages) { num++; }
    return num;
  },

  /*
    Allows the user to add additional menu icons to the PageManager.
    
     - imgId: The scs_sprite image id
     - msg:   The overlib message to display when hovering
     - func:  The function to call when clicked on
  */
  "addMenuIcon" : function(imgId,msg,func,avail)
  {
    if ( isUndefinedOrNull( avail ) ) { avail = null; }

    this.menuIcons.push( { 'icon' : imgId,
                           'msg'  : msg,
                           'func' : func,
                           'avail': avail } );
  },

  /*
    Allows the user to add a preference item for this current instance of 
    the PageManager.  The ID should be the specific ID (for instance the 
    Track PubEdID) for this preference, and the description should be 
    something to describe what the user is saving by 
 
    For example:
      pageManager.addPrefItem("pub0101", "Save for this publication");
      pageManager.addPrefItem("ptBROADSHEET", "Save for this page type");
 
    These need to be unique, so that you will not have overlapping
    preferences saved.  In the above example, the prefixes ensure that 
    in the case that a pub/ed id matches a page type id, we won't overlap

    Note that the priorty for the default 'By Application' option is 0, 
    and higher numbers indicate higher prioritys, so by default, all 
    additional pref items are of a higher prioerity than the default
  */
  "addPrefItem" : function(id, desc, priority)
  {
    if(isUndefinedOrNull(priority)) { priority = 1; }
    if(id.length > 12)
    { 
      scs_err("ID's for Preference Items cannot be longer than 12 characters"); 
      return;
    }
 
    this.prefItems.push({'id' : id, 'desc' : desc, 'priority' : priority});

    // Sort in reverse order (to make higher priorities earlier)
    var cmpFunc = function(a,b) { return compare(b.priority, a.priority); };
    this.prefItems.sort(cmpFunc);
  },

  /***********************************************************
    Internal functions for PageManager
  ************************************************************/
  
  /*
    savePrefs saves off a serialized version of the current 
    PageManager object, after removing any non-preference 
    properties.  Basically, we perform a deep clone, and then 
    remove anything the user doesn't have the ability to change.
    We leave all of the toggle-able settings, such as
     - Pages per row
     - View by (Section|Group|Zone|Page)
     - Number of (Section|Group|Zone|Page) per page  
  */
  "savePrefs" : function()
  {
    nd();
    
    var rollbackSettings = this.preserveSettings();

    // Update our internal settings, but dont redraw
    this.updateDisplaySettings(false);
    
    var jsonStr = JSON.stringify(this.preserveSettings());
 
    var sel = this.W_OBJS.PREFTYPES_SEL;
    var itemId = this.id;
    if(!isUndefinedOrNull(sel))
      { itemId += sel.value; }
    
    var _self = this;
    var myCallback = function(lrm)
    { 
      _self.displaySettingsFloatingDiv.hide(); 
      _self._draw_lock = false;
      _self.draw();
    }

    var myErrback = function()
    {
      _self.displaySettingsFloatingDiv.hide();
      for(var i in rollbackSettings) 
        { _self[i] = rollbackSettings[i]; }
      scs_alert("ERROR_FAILEDWRITE");
    }

    /* Type = 1        Save by user
       PrefType = 05   Save a default PageManager preference
       BlobVal         The serialized preference object
    */
    var keys = [ "type", "preftype", "itemid", "blobval" ];
    var vals = [ "1",    "05",       itemId,  jsonStr   ];
 
    genericAjaxRequest( "saveuserpref", false, myCallback, myErrback, keys, vals, menuManager.getLocCGI_Main() + "/spice.pl" );
  },

  "getSetPrefStateFunc" : function(pm, state)
  {
    return function() { pm._getPrefState = state; }
  },

  "getPrefs" : function()
  {
    if(this._getPrefState !== SCS_PM.PREFS_NOT_REQUESTED) { return; }
  
    // Generate a comma separated list of itemId's to look for
    var itemIds = "";
    var _self = this;
    forEach(this.prefItems, function(p)
    {
      itemIds += (itemIds === "" ? "" : ",") + _self.id + p.id;
    });

    // Find out the user pref ppr, if there is one
    var keys = [ "type", "preftype", "itemid" ];
    var vals = [ "1",    "05",       itemIds  ];
  
    var _self = this;
    var myCallback = function ( lrm ) {
      var jsonStr = lrm.getOther( "BlobVal" );
      var jsonObj = parseJSON(jsonStr);
      for(var i in jsonObj) 
        { _self[i] = jsonObj[i]; }
    }

    var errCallback = function( lrm ) {
      /* Do nothing if we fail to load them */
    }
 
    this._getPrefState = SCS_PM.PREFS_REQUEST_MADE;

    this._getPrefDeferred = genericAjaxRequest( "getuserpref", false, myCallback, errCallback, 
                                                keys, vals, menuManager.getLocCGI_Main() + "/spice.pl",
                                                null, null, null, true );  

    // Make sure to update our state when we finish, on either a success or failure.
    this._getPrefDeferred.addBoth(this.getSetPrefStateFunc(this, SCS_PM.PREFS_REQUEST_DONE));
  },

  "appendKeyBox" : function(parent, type, str)
  {
    if(!isUndefinedOrNull(this.getColor(type)))
    {
      var fontColor = "black";
      var backColor = this.getColor( type );
      var span = SPAN( { "class": "keybox scs_center scs_black" }, str );
      if ( ( backColor == "black" ) || ( backColor == "#333" ) ) {
      	fontColor = "white";
      }
      setStyle(span, { 'background-color' : backColor,
                       'color' : fontColor } );
      appendChildNodes(parent, span);
    }
  },

  /* This is the save function that if there is only one type of save 
     available, it just saves automatically, but if there are multiple 
     types, it opens the Display Seting floating div so the user can 
     choose how they want to save the settings */
  "smartSaveFunc" : function()
  {
    if(this.prefItems.length > 1)
      { this.editDisplaySettings() ;}
    else
      { this.savePrefs(); }
    return true;
  },

  /* Create the header div for the PageManager frame */
  "getHeaderDiv" : function()
  {
    var div = DIV();
    addElementClass(div, "scs_b w100");
    setStyle(div, { 'float' : 'left',
                    'clear' : 'left' }); 
 
    var table = TABLE({ "id": "pm_header_table" }, null);
    var tbody = TBODY();
    var tr = TR();
    var tdl = TD( { 'id': 'pm_header_slider' } );
    var tdc = TD( { 'id': 'pm_header_nav' } );
    var tdr = TD( { 'id': 'actions' } );

    var sliderElement = INPUT( { "name": "slider", "type": "range",
                                 "min": "45", "max": "500", "step": "4" } );
    /*
     * If the pagePerRow value is invalid, just set it somewhere in the middle.
     */
    if ( this.pagesPerRow < 45 || this.pagesPerRow > 500 ) {
      this.pagesPerRow = 225;
    }

    sliderElement.value = this.pagesPerRow;

    connect( sliderElement, "onchange", this,
             function() {
               this.pagesPerRow = sliderElement.value;
               this.draw();
             } );
    /* Create the save icon */
    var saveLink = getSpriteIMGElement("BLACKDISK", "Save View Preferences");
    connect(saveLink, "onclick", this.smartSaveFunc);
    connectSCSHelpOverlib(saveLink, (this.prefItems.length > 1) ? "pm_save" : "pm_save_short");

    appendChildNodes( tdl, LABEL( "Zoom:  " ), sliderElement,
                      SPAN("\u00a0\u00a0"), saveLink );

    /* Construct the center TD */
    var firstPage,lastPage,totalPages

    if(this.viewPagesBy === SCS_PM.VIEW_TYPE_ALL)
    {
      totalPages = this.getTotalNumberOfPages();
      firstPage = (((this.currentPage-1) * this.itemsPerPage) + 1);
      lastPage = firstPage + this.itemsPerPage - 1;
      lastPage = (lastPage > totalPages) ? totalPages : lastPage;
    }
    else
    {
      var arr;
      if(this.viewPagesBy === SCS_PM.VIEW_TYPE_SECTION)
        { arr = this.sections; }
      else if(this.viewPagesBy === SCS_PM.VIEW_TYPE_ZONE)
        { arr = this.zones; }
      else if(this.viewPagesBy === SCS_PM.VIEW_TYPE_GROUP)
        { arr = this.groups; }
      else
        { throw("Invalid view type specified."); }
      
      if(this.viewPagesFilter === "All")
      {
        totalPages = arr.length - 1;
        firstPage = (((this.currentPage-1) * this.itemsPerPage) + 1);
        lastPage = firstPage + this.itemsPerPage - 1;
        lastPage = (lastPage > totalPages) ? totalPages : lastPage;
      }
      else
      {
        firstPage = 1;
        lastPage = 1;
        totalPages = 1;
      }
    }
  
    var $first = $j( '<button><i class="fa fa-step-backward fa-lg fa-fw"></i></button>' ),
        $prev = $j( '<button><i class="fa fa-backward fa-lg fa-fw"></i></button>' ),
        $next = $j( '<button><i class="fa fa-forward fa-lg fa-fw"></i></button>' ),
        $last = $j( '<button><i class="fa fa-step-forward fa-lg fa-fw"></i></button>' );

    if(this.currentPage > 1)
    { 
      $prev.attr( "title", "Previous Page" ).click( this.previousPage );
      $first.attr( "title", "First Page" ).click( this.firstPage );
    }
    else
    {
      $prev.attr( "title", "No more pages" );
      $prev.attr( "disabled", "disabled" );
      $first.attr( "title", "No more pages" );
      $first.attr( "disabled", "disabled" );
    }
    
    if(lastPage < totalPages)
    {
      $next.attr( "title", "Next Page" ).click( this.nextPage );
      $last.attr( "title", "Last Page" ).click( this.lastPage );
    }
    else
    { 
      $next.attr( "title", "No more pages");
      $next.attr( "disabled", "disabled" );
      $last.attr( "title", "No more pages");
      $last.attr( "disabled", "disabled" );
    }

    appendChildNodes(tdc, $first[0], $prev[0]);
     
    if(this.viewPagesBy === SCS_PM.VIEW_TYPE_ALL)
    { 
      appendChildNodes(tdc, " Displaying page(s) " + 
                            firstPage + 
                            " - " + 
                            lastPage + 
                            " of " +
                            totalPages);
    }
    else
    { 
      if(this.viewPagesBy === SCS_PM.VIEW_TYPE_SECTION)
        { appendChildNodes(tdc, " Displaying section(s) "); }
      else if(this.viewPagesBy === SCS_PM.VIEW_TYPE_ZONE)
        { appendChildNodes(tdc, " Displaying zone(s) "); }
      else if(this.viewPagesBy === SCS_PM.VIEW_TYPE_GROUP)
        { appendChildNodes(tdc, " Displaying group(s) "); }
      else
        { throw("Invalid view type specified."); }
  
      appendChildNodes(tdc, firstPage);
  
      if(lastPage > firstPage)
        { appendChildNodes(tdc, " - " + lastPage); }

      appendChildNodes(tdc, " of " + totalPages);
    }

    appendChildNodes(tdc, $next[0], $last[0]);
   

    /* Construct the Right TD */
    if ( !isUndefinedOrNull( this.printCommand ) ) {
      this.redrawActionsMenu( tdr );
    }

    appendChildNodes(tr, tdl, tdc, tdr);
    appendChildNodes(tbody, tr)

    /* Generate another row to hold the legend */
    var tr = TR();
    var td = TD( { 'class':'scs_right scs_black',
                   'colspan' : '3' },
                 SPAN( getLangString( "KEY" ) + ": " ) );
    
    for(var i in this.adTypes)
    {
      this.appendKeyBox(td, i, this.adTypes[i].label);
    }

    appendChildNodes(tr, td);
    appendChildNodes(tbody, tr);
    appendChildNodes(table, tbody);
    appendChildNodes(div, table);

    return div;
  },

  /* Find out what the ratio was for the last page I drew */
  "getLastPmToPx" : function()
  {
    return this._pmToPx.last;
  },

  /* What is the average number of columns for all pages I've drawn so far */
  "getAvgNumColumns" : function()
  {
    return this._avgNumColumns.avg;
  },

  /* Navigate to the first page of pages */
  "firstPage" : function()
  {
    this.currentPage = 1;
    this.draw();
  },

  /* Navigate to the previous page of pages */
  "previousPage" : function()
  {
    this.currentPage--;
    if(this.currentPage <= 0) { this.currentPage = 1; }
    this.draw();
  },

  /* Navigate to the next page of pages */
  "nextPage" : function()
  {
    this.currentPage++;
/*
    // Forget what this was for...but it doesnt seem needed??
    if( (this.currentPage-1) * this.itemsPerPage >= this.getTotalNumberOfPages() ) 
    {
      this.currentPage = Math.floor(this.getTotalNumberOfPages()/this.itemsPerPage); 
    }
*/
    this.draw();
  },

  /* Navigate to the last page of pages */
  "lastPage" : function()
  {
    if(this.viewPagesBy === SCS_PM.VIEW_TYPE_ALL)
    { 
      this.currentPage = Math.ceil(this.getTotalNumberOfPages()/this.itemsPerPage); 
    }
    else
    {
      var arr;
      if(this.viewPagesBy === SCS_PM.VIEW_TYPE_SECTION)
        { arr = this.sections; }
      else if(this.viewPagesBy === SCS_PM.VIEW_TYPE_ZONE)
        { arr = this.zones; }
      else if(this.viewPagesBy === SCS_PM.VIEW_TYPE_GROUP)
        { arr = this.groups; }
      else
        { throw("Invalid view type specified."); }

      // -1 to account for the "All" entry at the beginning
      this.currentPage = Math.ceil((arr.length-1)/this.itemsPerPage); 
    }

    this.draw();
  },

  /* Create and return an array of page identifiers in the proper 
     order based on current display settings */
  "getPageOrders" : function()
  {
    // Determine the order to draw in
    var pageorders = [];
    for(var i in this.pages)
    { 
      if(this.viewPagesBy === SCS_PM.VIEW_TYPE_ZONE && this.pages[i].iszoned)
      {
        var _self = this;
        var _i = i;
        forEach(this.pages[i].zones, function(z)
        {
          var sortObj = { 'pageorder'  : _self.pages[_i].pageorder,
                          'pageid'     : _i,
                          'zoneid'     : z } ;

          pageorders.push(sortObj); 
        });
      }
      else
      {
        var sortObj = { 'pageorder'  : this.pages[i].pageorder,
                        'pageid'     : i,
                        'zoneid'     : this.pages[i].zoneid } ;

        if(!isUndefinedOrNull(this.groupPagesBy))
          { sortObj[this.groupPagesBy] = this.pages[i][this.groupPagesBy]; }

        pageorders.push(sortObj); 
      }
    }
    
    pageorders.sort(SCS_PM.getPageSortFunc(this.groupPagesBy));
    return pageorders;
  },

  /* Decide what our start and end indexes are in the pageorders 
     array based on current Display Settings */
  "calculateSectionGroupRange" : function(pageorders)
  {
    var fldId,arr;
    if(this.viewPagesBy === SCS_PM.VIEW_TYPE_SECTION)
    {
      fldId = "sectionid";
      arr = this.sections;
    }
    else if(this.viewPagesBy === SCS_PM.VIEW_TYPE_ZONE)
    {
      fldId = "zoneid";
      arr = [];
      forEach(this.zones, function(z) { arr.push(z.id); });
    }
    else if(this.viewPagesBy === SCS_PM.VIEW_TYPE_GROUP)
    {
      fldId = "group";
      arr = this.groups;
    }
    else
    {
      throw("Invalid view type specified in calculateSectionGroupRange()");
    }

    var sItem,eItem,start,end;
    var cmpFunc = getFieldCmpFunc(fldId);
    var notEqFunc = function(a,b) 
    { 
      var c = compare(a,b); 
      if(c === 0) { return 1; }
      return 0;
    };

    if(this.viewPagesFilter === "All")
    {
      var sIndex = (this.currentPage-1)*(this.itemsPerPage)+1;  // Add 1 to avoid the 'All' entry 
      sItem = (sIndex < arr.length) ? arr[sIndex] : (arr.length > 1) ? arr[1] : null;
      eItem = (sIndex+this.itemsPerPage < arr.length) ? arr[sIndex+this.itemsPerPage] : null;
    }
    else
    {
      var sIndex = arr.indexOf( this.viewPagesFilter );
      sItem = arr[sIndex];
      eItem = (sIndex+1 < arr.length) ? arr[sIndex+1] : null;
    }

    // Since you can't just pass an object {fldId:sItem} because it will 
    // literally have a field called 'fldId', we need to create objects here 
    // and subscript them with fldId to get it's value as the field name.
    start = objIndexOf( pageorders, fldId, sItem );
    end = objIndexOf( pageorders, fldId, eItem );

    // Update if we didn't find the end section to just draw everything
    end = (end < 0) ? pageorders.length : end;

    return {'start':start,'end':end};
  },

  /* Draw all the pages and boxes in the frame */
  "draw" : function(progBar)
  {
    if( this._draw_lock ) {
      return;
    }

    var n = isUndefinedOrNull; // Quick alias
    if(n(progBar)) { progBar = false; }
    this._progBar = progBar;

    if(this._getPrefState === SCS_PM.PREFS_NOT_REQUESTED)
      { this.getPrefs(); }

    if( this._getPrefState === SCS_PM.PREFS_REQUEST_MADE &&
        !isUndefinedOrNull(this._getPrefDeferred) )
    {
      this._getPrefDeferred.addBoth(this.draw);
      return this._getPrefDeferred;
    }

    if(this._getPrefState === SCS_PM.PREFS_REQUEST_DONE)
    {

      var d = this._draw();
      if ( ! isUndefinedOrNull( this.drawCallback ) ) {
        d.addCallback( this.drawCallback );
      }
      return d;
    }
  },

  "_draw" : function()
  {
    var n = isUndefinedOrNull; // Quick alias

    var numPages = this.getTotalNumberOfPages();
    /*
    // Old warning message no longer needed because we can page through
    var msg = "You are about to draw " + n + " pages, this may take a while.";
    if( numPages > 50 && !scs_confirm(msg))
      { return false; }
    */
   
    replaceChildNodes(this.frame);
    
    if(numPages <= 0) { return succeed(); }

    if(this._progBar) { openProgressBar(); }

    appendChildNodes(this.frame, this.getHeaderDiv());

    var _self = this;
    this._pmToPx =        { 'last' : 0,'width':0 };
    this._avgNumColumns = { 'sum' : 0, 'avg' : 0 };

    var start, end, pageorders;

    /* This block sets our pageorders array, and the start and end indexes */
    if(this.viewPagesBy === SCS_PM.VIEW_TYPE_ALL)
    {
      this.groupPagesBy = SCS_PM.GROUP_TYPE_ALL;
      pageorders = this.getPageOrders();
      start = (this.currentPage-1)*(this.itemsPerPage); 
      end = start + this.itemsPerPage; 
    }
    else
    {
      // HEre we set some flags that depend on each other
      if(this.viewPagesBy === SCS_PM.VIEW_TYPE_SECTION)
      { 
        // If we view by section, then we must group by section
        this.groupPagesBy = SCS_PM.GROUP_TYPE_SECTION; 
      }
      else if(this.viewPagesBy === SCS_PM.VIEW_TYPE_ZONE)
      { 
        // If we view by zone, then we must group by zone and change
        // our zoneType to COMMON, not ALL
        this.groupPagesBy = SCS_PM.GROUP_TYPE_ZONE; 
        this.zoneType = SCS_PM.ZONE_TYPE_COMMON;
      }
      else if(this.viewPagesBy === SCS_PM.VIEW_TYPE_GROUP)
      { 
        // If we view by group, then we must group by group
        this.groupPagesBy = SCS_PM.GROUP_TYPE_GROUP; 
      }

      pageorders = this.getPageOrders();
      var obj = this.calculateSectionGroupRange(pageorders);
      start = obj.start;
      end = obj.end;
    }

    // Variables for use during the loop
    var rowDiv = null;
    var newRow = true;
    var lastPageGroup = "";
    var pageGroupPageNum = 0;
    var pageGroupDiv = null;
    var currentZoneIndex = 0;
    var usedWidth = 0;
    var frameWidth = this.getFrameWidth();

    /* Loop from start to end in pageorders */ 
    for(var i = start; i < end && i < pageorders.length; i++)
    {
      var p = _self.pages[pageorders[i].pageid];

      if(this.groupPagesBy === SCS_PM.GROUP_TYPE_ZONE)
        { currentZoneIndex = p.zones.indexOf( pageorders[i].zoneid ); }

      // Set the first group of pages
      if(!n(this.groupPagesBy))
      { 
        var groupId,groupName;
        if(this.groupPagesBy === SCS_PM.GROUP_TYPE_ZONE)
        { 
          groupId = p.zones[currentZoneIndex]; 
          var gi = objIndexOf( this.zones, "id", groupId );
          groupName = this.zones[gi].name;
        }
        else
        { 
          groupId = p[this.groupPagesBy]; 
          groupName = groupId;
        }

        // If we're a new group of pages, let's set this so we start a new row
        if(groupId !== lastPageGroup)
        { 
          newRow = true;
          
          // Append a pageGroup label div
          pageGroupDiv = DIV( {'class':'scs_left',
                               'style':'float:left;clear:left;margin:0px 0px 15px;padding: 0px 15px;' + 
                                       'font-size:2em;font-weight:bold;width: 100%;'}, 
                              SPAN(null,groupName) );
          appendChildNodes(this.frame, pageGroupDiv);
          pageGroupPageNum = 1;
        }
      }
      
      var newPageNode = p.getPageNode(p.cssclass, p.zones[currentZoneIndex]);

      // Do I need to start a new row?
      if ( newRow ) { 
        if (typeof rowDiv !== 'undefined' && rowDiv !== null && this.noWrap) {
          var fpw = sum( map( itemgetter( "clientWidth" ), rowDiv.children ), 0 );
          setStyle(rowDiv, {'width': fpw.toString() + 'px'});
        }

        rowDiv = DIV({'style':'float:left;clear:both;width:100%;'}, null);

        if(n(this.groupPagesBy) && i === start)
        {
          // We need some padding at the top
          setStyle(rowDiv, { 'margin-top' : '25px' });
        }

        if (this.noWrap) {
          var wrapperWidth = this.frame.clientWidth + "px";
          var wrapper = DIV( null, rowDiv );
          setStyle( wrapper, { 'overflow-x': 'scroll', 'width': wrapperWidth,
                               'padding-top': '18px' } );
          appendChildNodes(this.frame, wrapper);
        } else {
          appendChildNodes(this.frame, rowDiv);
        }
        usedWidth = 0;
        newRow = false;
      }

      appendChildNodes(rowDiv, newPageNode);

      // Add in half the margin space plus the borders
      usedWidth = usedWidth + ( p.pagewidth * p.pmToPx ) + 42;              
      
      if(!n(this.groupPagesBy))
      {
        // Set this for the next page
        if(this.groupPagesBy === SCS_PM.GROUP_TYPE_ZONE)
        {
          lastPageGroup = p.zones[currentZoneIndex];
        }
        else
        {
          lastPageGroup = p[this.groupPagesBy];
        }
        pageGroupPageNum++;
      }
      
      // Set some average numbers for use by future pages
      this._pmToPx.last = p.pmToPx;
      this._pmToPx.width = p.pagewidth;

      this._avgNumColumns.sum += p.numcolumns;
      this._avgNumColumns.avg = Math.round(this._avgNumColumns.sum/(i-start+1));

      // Are we drawing zones?
      if(p.iszoned && this.zoneType === SCS_PM.ZONE_TYPE_ALL && currentZoneIndex < p.zones.length - 1)
      {
        i--;
        currentZoneIndex++
      }
      else if(currentZoneIndex == p.zones.length-1)
      {
        currentZoneIndex = 0;
      }
    }

    // Draw boxes and erase small vertical rules between ads
    //   col_height is the height of current starting point of the rule between cols i and i+1 (0-based)
    //     (the page is inverted, so the heights count from the top down)
    //   when placing an n-column ad (with n > 1) in columns i to i+n-1
    //     for i in i to i+n-2
    //        if ad_pos_y - col_height(i) < min_rule_size then
    //          erase the rule between cols i and i+1 from col_height(i) to ad_pos
    //        col_height(i) = ad_pos_y + ad_size_y
    //   finish the page as if the edge were a full-width ad at the maximum pos_y
    //
    // Erasing rules seems backwards at first, but it might be more efficient.
    // The column rules come for free with the columns, so erasing rules saves
    // work on sessions with many empty pages that do not need any changes.
    // The pixel calculations are the same for drawing and erasing;
    // only the test to draw or erase the rule is inverted.
    // Since the main loop is for boxes, it misses pages with no boxes,
    // which is no problem when erasing rules but requires an extra loop
    // over the pages when drawing rules.

    var col_height = []; // starting point of rule between cols i and i+1 (0-based)
    var col; // loop counter
    var min_rule_size = 0; // minimum rule size to preserve

    /* Draw all boxes on this page */
    for(var i in this.boxes)
    {
      var box = this.boxes[i];
      var page = this.pages[box.pageid];     // The page object for this box
      var element = this.elements[box.elementid];     // The page object for this box
      
      if(!n(page) && !n(element) && element.isplaced && element.blocktype != "HO")
      {
        var pageDiv = $(this.getPageId(page)); // The drawn page DIV
        if(!n(pageDiv))
        {
          appendChildNodes(pageDiv, box.getBoxNode());

          if ( !n(element.posxcols) && ( element.posxcols > 0 ) ) {
            numCols = element.posxcols;
          } else {
            numCols = page.findColumnNum( box.posx );
          }
          
          if (!n(element.widthcols) && element.widthcols > 1) {
	    var col_limit = numCols + element.widthcols - 2;
	    if (col_limit >= page.numcolumns) col_limit = page.numcolumns - 1;
	    for (col = numCols; col <= col_limit; col++) {
	      if (box.posy - col_height[ col ] < min_rule_size) {
		box.appendRuleNode(pageDiv, box.getId(), page, col, col_height[ col ], box.posy);
	      }
	      col_height[ col ] = box.posy + box.sizey;
	    }
	  }
        }
      }
    }

    if (this.noWrap) {
      var fpw = sum( map( itemgetter( "clientWidth" ), rowDiv.children ), 0 );
      setStyle(rowDiv, {'width': fpw.toString()+'px'});
    }
    if(this._progBar) { closeProgressBar(); }
 
    return succeed();
  },

  "redrawActionsMenu": function( actionsElem ) {
    var actions = isUndefinedOrNull( actionsElem ) ? $( 'actions' ) : actionsElem;
    replaceChildNodes( actions );
    forEach(this.menuIcons, function( m ) {
      if ( isUndefinedOrNull( m.avail ) || m.avail() ) {
        var img = getSpriteIMGElement(m.icon,m.msg);
        connect( img, "onclick", m.func );
        appendChildNodes( actions, img );
      }
    } );
  }  
}


var Page = function(obj,manager)
{
  bindMethods( this );
  this.init(obj,manager);
}

Page.prototype = 
{
  "init" : function(obj,manager)
  {
    var n = isUndefinedOrNull;
    if(n(manager))
      { scs_err("Invalid PageManager object specified in Page constructor.") }

    // Default values for parameters not passed
    var defaultPageObj = 
    { 'pageid'      : null,       // Required?
      'pubid'       : null,       // Required?
      'issueid'     : null,       // Required?
      'pagewidth'   : null,       // Required
      'gutterwidth' : null,       // Required
      'columnwidth' : null,       // Required
      'pageheight'  : null,       // Required
      'numcolumns'  : null,       // Required     
      'pagetitle'   : null,
      'webpagetitle': null,
      'pagetitle2'  : null,
      'pageorder'   : null,
      'pagenum'     : null,
      'pagetip'     : null,
      'manager'     : manager,
      'pmToPx'      : null,
      'pmToPxChanged' : false,
      'pagewidthpx' : null,	// page width in pixels
      'gutterwidthpx' : null,	// gutter width in pixels
      'gutterlinepx' : null,	// width of line in pixels
      'boxindentpx' : null,	// indent for boxes
      'borderwidthpx' : null	// border inside page in pixels
    };

    // First set anything the user passed in, then set any defaults
    setdefault(this, obj);
    setdefault(this, defaultPageObj);

    if(n(this.pageid) || trim(this.pageid) == "")
      { scs_Err("Invalid data specified for Page constructor."); }

    // Parse numbers from numstrings
    this.numcolumns = (this.numcolumns == "") ? null : parseInt(this.numcolumns,10);
    this.pageheight = (this.pageheight == "") ? null : parseInt(this.pageheight,10);
    /* this.pagewidth = (this.pagewidth == "") ? null : parseInt(this.pagewidth,10); */
    this.gutterwidth = (this.gutterwidth == "") ? null : parseInt(this.gutterwidth,10);
    this.columnwidth = (this.columnwidth == "") ? null : parseInt(this.columnwidth,10);
    this.pagewidth = this.numcolumns * this.columnwidth + ((this.numcolumns > 1)? (this.numcolumns-1) * this.gutterwidth: 0);
    this.pageorder = (this.pageorder == "") ? null : parseInt(this.pageorder,10);
    this.pagenum = (this.pagenum == "") ? null : parseInt(this.pagenum,10);
  },

  /************************************************************
   * Accessor functions
   ************************************************************/

  /* Get my unique identifier from the manager */
  "getId" : function(zone)
  {
    return this.manager.getPageId(this);
  },

  /**
   * Return all the boxes on this page.
   */
  "getBoxes": function() {
    var pageid = this.pageid;
    return filter( function( b ) { return b.pageid == pageid },
                   this.manager.boxes );
  },

  /* Get my page height in pixels */
  "heightPx": function()
  {
    return this.pagModToPx(this.pageheight);
  },

  /* Get my page width in pixels */
  "widthPx": function()
  {
    return this.pagModToPx(this.pagewidth, false)+1;
  },

  /* Return the left pixel of a column (the space where ads can go if the ads have no margin)
   *   Includes all columns and gutters to the left
   *   The column number is 0-based
   */
  "colStartPx" : function(i)
  {
    var col = this.borderwidthpx + Math.round((i * (this.columnwidth + this.gutterwidth)) * this.pmToPx);
    if (col >= this.pagewithpx) col = this.pagewidthpx;
    return col;
  },

  /* 
    Get my column width in pixels.  Alternating columns switch between 
    rounding up and down to account for accumulation of rounding differences
  */
  "colWidthPx" : function(i)
  {
    /*
    var c = (i%2 == 1);
    return this.pagModToPx(this.columnwidth,c);
    */
    return Math.round(this.columnwidth * this.pmToPx);
  },

  /*
    Get the gutter width to the left of column 'i'.  Uses the same 
    rounding logic as column widths
  */
  "gutterWidthPx" : function(i)
  {
    /*
    var c = (i%2 == 0);
    var g = this.pagModToPx(this.gutterwidth,c);
    return (g < 1 && this.gutterwidth !== 0) ? 1 : g;
    */
    var g = Math.round(this.gutterwidth * this.pmToPx);
    return (g < 1 && this.gutterwidth != 0) ? 1 : g;
  },

  /*
    Find out the total width of the columns up to column number i.  
    This includes width and borders (gutters)
  */
  "totalColWidthPx" : function(i)
  {
    /*
    var sum = 0;
    for(var j = 0; j < i; j++)
      { sum += this.colWidthPx(j) + ((j > 0) ? this.gutterWidthPx(j) : 0); }
    return sum;
    */

    var sum2 = i * this.columnwidth;
    if (i > 1) sum2 += (i - 1) * this.gutterwidth;
    sum2 = Math.round(sum2 * this.pmToPx);

    return sum2;
  },

  /************************************************************
   * Calculation functions
   ************************************************************/
  
  /* 
   Globally used function to convert PagMod units to pixels.  This is 
   specific to a page and depends on the number of pages per row.
   The optional second parameter indicates that instead of Math.round, 
   we should use Math.ceil (if true) or Math.floor (if false).

   The 'ceil' parameter is needed when getting width of columns and 
   gutters where we alternate between rounding up and down to avoid
   accumulating rounding differences.
  */     
  "pagModToPx" : function(num,ceil)
  {
    if(isUndefinedOrNull(num)) 
      { scs_err("Unable to convert '" + num + "' to pixels in Page.pagModtoPx()"); }
    
    // Calculate the ratio for this page, given the number of pages per row
    var roundFunc = null;
    if(isUndefinedOrNull(ceil))
      { roundFunc = Math.round; }
    else if(ceil)
      { roundFunc = Math.ceil; }
    else
      { roundFunc = Math.floor; }

    return parseInt(roundFunc(num*this.pmToPx),10);
  },

  /*
    Set the PagMod To PX ratio for this page.
  */
  "setPmToPx" : function()
  {
    this.isSuperPage = ( this.fullpagecols == "" ) ? false : ( this.numcolumns > ( Number(this.fullpagecols) + 2 ) );

    // We want to use the previous ratio if:
    //  1) We are a superpage, so width will be proportional
    //  2) We are the same width, so height will be proportional

    /* Note: If it's an issue that doing it this way causes pages 
       that are of different widths to be unproportional (because 
       when we come across smaller or larger (width) pages, we fit
       them in the same amount of width space so our pages per 
       row number holds up, we can change the , second check below 
       to a <=, which will cause smaller pages to still get drawn 
       at the same proportion...larger pages we should still redraw 
       to try to avoid fitting less than our set number of pages 
       per row and thus causing a page to drop down, and potentially 
       catch an edge while trying to float left. */

    if( this.pagewidth == this.manager._pmToPx.width )
    {
      this.pmToPx = this.manager.getLastPmToPx();
    }
    else
    {
      // Set the pixel ratio based off the width of the section we 
      // are drawing in.
      var fw = this.manager.getFrameWidth();  // Available space to draw in (px)
      //var ppr = this.manager.pagesPerRow;     // Pages per row
      var cols = this.numcolumns;             // Columns per page
      var ratio = ( this.fullpagecols == "" ) ? 1 : ( this.fullpagecols / cols );
      var gw = this.gutterwidth;              // in PM Units
      var pw = this.pagewidth;                // in PM Units

      var spp = 40 + 2; // Space per page = 40 px in margins and 2px in borders

      // How many pixels can we allocate to actual page DIV elements.  
      var totalPxForPages = 500;

      //var pxPerPage = totalPxForPages / ppr;  // Divide remaining space per page
      var minWidth = 45;
//      var pxPerPage = minWidth+((totalPxForPages-minWidth)*(this.manager.pagesPerRow / 100e2));
      var pxPerPage = this.manager.pagesPerRow;
      this.pmToPx = pxPerPage / ( pw * ratio );      // Divide pixels per page by the pag mod units per page
    }

    // Calculate pixel values
    this.pagewidthpx = Math.round(this.pagewidth * this.pmToPx);
    this.gutterwidthpx = Math.round(this.gutterwidth * this.pmToPx);
    this.gutterwidthpx = 2 * Math.floor((this.gutterwidthpx - 1) / 2) + 1;	// force odd so the line can be centered in the gutter
    if (this.gutterwidthpx < 1) this.gutterwidthpx = 1;
    // this.gutterlinepx = Math.round((this.gutterwidthpx + 2) / 3);
    // if (this.gutterlinepx < 1) this.gutterlinepx = 1;
    this.gutterlinepx = 1;							// force the line to 1 pixel
    this.boxindentpx =
      Math.round(
        Math.max(
          (this.gutterwidthpx - this.gutterlinepx + 1) / 2,
          (this.columnwidth * this.pmToPx) / 20));
    this.borderwidthpx = 1;

    // Set a flag in all page and box elements telling them 
    // they need to recalculate their positional information
    for(var i in this.manager.pages)
      { this.manager.pages[i].pmToPxChanged = true; }
    for(var i in this.manager.boxes)
      { this.manager.boxes[i].pmToPxChanged = true; }
  },

  /*
    Get and return a footer div to place below the page.
    This consists of webpagetitle and pagetitle 2 is supplied, 
    and if a pagetip is supplied, an overlib will be attached.
  */
  "getFooterDiv" : function(zone)
  {
    if(isUndefinedOrNull(this.webpagetitle)) { return null };

    var footerDiv = DIV( { "class" : "scs_page_footer single_page",
                           "id"    : "Footer_"  + this.getId(zone),
                           "style" : "width: " + this.widthPx() + "px;" }, 
                         null);

    if(strip(this.webpagetitle) + strip(this.pagetitle2) != "")
    {
      appendVariableSizeTextString(footerDiv, this.webpagetitle);
      appendVariableSizeTextString(footerDiv, this.pagetitle2);

      SCS_PM.attachOverlib(footerDiv, this.pagetip);
    }
    else
    {
      appendChildNodes(footerDiv, BR(), BR());
    }

    return footerDiv;
  },

  /*
    Return a CSS style string for the borders in the given column ID.
    Columns > 1 get gutter borders, while the first and last have 
    outer skinny page borders.  All columns have a top and bottom 
    skinny border.
  */
  "getColumnBorderString" : function(i)
  {
    var s = "1px solid black;";
    var g = this.gutterlinepx;
    var l =  ((g <= 0) ? 1 : g) + "px solid gray;";
    var getB = function(loc,type)
      { return "border-" + loc + ": " + type; }

    if(i < this.numcolumns-1)
    {
      return getB("right", l);
    } else return "";
  },

  /*
    Find out what zero-indexed column the PagMod x-coordinate lies in
  */
  "findColumnNum" : function(x)
  {
    var r = 0;
    for(var i = 0; i < this.numcolumns; i++)
    {
      r += ((i > 0) ? this.gutterwidth : 0) + this.columnwidth;
      if(x < r) { return i; }      
    } 
    return this.numcolumns-1;
  },

  /* 
    Return the HTML column node for the given PagMod x coordinate 
  */
  "getColumnNode" : function(x,xIsNum,zone)
  {
    if(isUndefinedOrNull(xIsNum)) { xIsNum = false; }
    var colNum = xIsNum ? x : this.findColumnNum(x);
    var pNode = $(this.manager.getPageId(this));
    if(!isUndefinedOrNull(pNode))
    {
      for(var i = 0; i < pNode.childNodes.length; i++)
      {
        var c = pNode.childNodes[i];
        if(c.nodeType == 1 && hasElementClass(c, "scs_column"))
        {
          if(colNum-- == 0) { return c; }
        }
      }
    }
    return null;
  },

  "connectEvent": function( node, eventName ) {
    if ( this[eventName] && typeof window[this[eventName]] == "function" ) {
      if ( eventName == "onclick" ) {
        addElementClass(node, "clickable");
      }
      connect( node, eventName, window[this[eventName]] );
    }
  },
 
  "getPageNode" : function(pClass,zone)
  {
    this.setPmToPx();

    var wrapperNode = DIV( { "class": "page_wrapper single_page" }, null );
    var pageHeaderDiv = DIV( { "class": "page_header",
                               "id": "page_header_" + this.pageid } );
    setStyle( pageHeaderDiv, { "width": this.widthPx()  + "px" } );

    // Create the outer page div
    var pageNode = DIV( { "class" : "scs_page " + pClass,
                          "id"    : this.getId(zone),
                          "style" : "width:  " + this.widthPx()  + "px; " + 
                                    "height: " + this.heightPx() + "px; " },
                        null);
    this.connectEvent( pageNode, "onclick" );
    this.connectEvent( pageNode, "onmouseover" );
    this.connectEvent( pageNode, "onmouseout" );
    var pageNum = "";

    // Generate our page number string
    if( this.manager.pageNumType !== SCS_PM.NUM_TYPE_NONE )
    {
      if( this.manager.pageNumType === SCS_PM.NUM_TYPE_SECTION )
        { pageNum = this.sectionid + "-" + this.sectionpagenum; }
      else if( this.manager.pageNumType === SCS_PM.NUM_TYPE_ABSOLUTE )
        { pageNum = this.pagenum; }

      if( this.manager.zoneType === SCS_PM.ZONE_TYPE_COMMON && this.iszoned) 
        { pageNum += " *"; }
      else if(this.manager.zoneType === SCS_PM.ZONE_TYPE_ALL && this.iszoned)
      { 
        var zi = objIndexOf( this.manager.zones.slice(1),
                             "id", parseInt(zone,10) );
        if(++zi > 0)
          { pageNum += " (" + this.manager.zones[zi].name + ")"; }
      }

      if(pageNum !== "")
      {
        // Create the page number div
        var pageNumDiv = SPAN( { "class": "scs_right" }, pageNum );
        setStyle( pageNumDiv,
                  { "width": this.widthPx() / 2 + "px",
                    "float": "right" } );
        appendChildNodes(pageHeaderDiv, pageNumDiv);
      }
    }

    // Add a zone icon indicator to the page if this page is zoned.
    var zoneInd = this.pagetitle2.substring(0,1);
    if(zoneInd == "*")
    {
      var zoneDiv = SPAN( { "class": "scs_left",
                            "style": "float:left;" },
                          getSpriteIMGElement( "BIGREVISIONS" ) );
      appendChildNodes(pageHeaderDiv,zoneDiv);
    }


    if(this.iscolorpage)
    {
      // Create the page number div
      var colorDiv = SPAN( { "class": "scs_left",
                             "style": "float:left;" },
                           getSpriteIMGElement( "COLORINDICATOR" ) );
      colorDiv.title = "Colors:  ";
      forEach( [ this.color1, this.color2, this.color3 ],
               function( c ) {
                 if ( ! isUndefinedOrNull( c ) ) {
                   colorDiv.title += c + " ";
                 }
               } );
      appendChildNodes(pageHeaderDiv, colorDiv);
    }

    appendChildNodes( wrapperNode, pageHeaderDiv );

    // Draw the columns and gutters

    var g = this.gutterWidthPx(i);
    if (g <= 0) g = 1;

    var gutteroffset = Math.floor((this.gutterwidthpx - this.gutterlinepx) / 2);
    var start = 0;
    var nextstart = this.colStartPx(0) - this.borderwidthpx;	// special offset for left border of first column

    for ( var i = 0; i < this.numcolumns; i++ ) {
      start = nextstart;
      nextstart = this.colStartPx( i + 1 ) - gutteroffset;

      // borderpx must match the left and right border calculations in getColumnBorderString
      var borderpx = ((i == 0)? this.borderwidthpx: 0) + ((i == this.numcolumns)? this.borderwidthpx: this.gutterlinepx);

      appendChildNodes(pageNode, DIV( { "class" : "scs_column",
                                        "style" : "left: "   + start + "px; " +
                                                  "width: "  + (nextstart - start - borderpx) + "px; " +
                                                  "height: " + this.heightPx() + "px; " +
                                                  this.getColumnBorderString(i) },
                                      null ));
    }
    appendChildNodes(wrapperNode, pageNode, this.getFooterDiv(zone));

    return wrapperNode;        
  },

  "getPageHeaderElement": function() {
    return $( "page_header_" + this.pageid );
  }
}


var Box = function(obj,manager)
{
  bindMethods( this );
  this.init(obj,manager);
}

Box.prototype = 
{
  "init" : function(obj,manager)
  {
    var n = isUndefinedOrNull;
    if(n(manager))
      { scs_err("Invalid PageManager object specified in Box constructor.") }

    // Default values for parameters not passed
    var defaultBoxObj = 
    { 'boxnum'      : null, // Required - unique identifier
      'pageid'      : null, // Required - What page am I drawn on
      'posx'        : null, // PagMod units
      'posy'        : null, // PagMod units
      'sizex'       : null, // PagMod units
      'sizey'       : null, // PagMod units
      'onclick'     : null,
      'widthpx'     : null, // Internal storage of my calculated width, for efficiency
      'heightpx'    : null, 
      'leftpx'      : null, 
      'toppx'       : null,
      'pmToPxChanged' : false,  // Has my page's ratio changed?  
                                // Do I need to recalculate my positional information?
      'manager'     : manager };

    // First set anything the user passed in, then set any defaults
    setdefault(this, obj);
    setdefault(this, defaultBoxObj);

    if(n(this.boxnum) || trim(this.boxnum) == "")
      { scs_err("Invalid data specified for Box constructor."); }

    var getNumericVal = function( n ) {
      return ( n == "" ) ? null : parseInt( n, 10 );
    }

    // Convert numstrings to numbers
    this.posx = getNumericVal( this.posx );
    this.posy = getNumericVal( this.posy );
    this.sizex = getNumericVal( this.sizex );
    this.sizey = getNumericVal( this.sizey );
    this.boxnum = parseInt( this.boxnum, 10 );
  },

  /*
    Get the Page object for the page I am going to be drawn on 
  */
  "getPage" : function()
  {
    return this.manager.pages[this.pageid];
  },

  "getPageElement": function() {
    return $( SCS_PM.PAGE_ID_PREFIX + this.pageid );
  },

  /* 
    Determine if it is OK to use my cached value
  */
  "useCachedValue" : function(val)
  {
    var n = isUndefinedOrNull;
    if(!n(this.pmToPxChanged) && !this.pmToPxChanged && !n(val))
      { return true; }
    return false;
  },

  /*
    Get my width in pixels.  There is some recalculation done 
    to prevent rounding errors.  The relaculation attempts to 
    line my right edge up with the right edge of the column 
    that I end in, so that the pixels line up correctly.
  */
  "widthPx" : function(zone)
  {
    if(this.useCachedValue(this.widthpx)) { return this.widthpx; }

    var n = isUndefinedOrNull;
    var page = this.manager.pages[this.pageid];
    var element = this.manager.elements[this.elementid];
    var w = null;
    if(!n(element.widthcols) && element.widthcols > 0)
    {
      // var offset = 3; // so we don't overlap the column borders
      if (n(element.posxcols)) {
	// column not known, convert the width
        w = element.widthcols * page.columnwidth;
        if (element.widthcols > 1) w += ((element.widthcols - 1) * page.gutterwidth);
        w = Math.round(w * page.pmToPx); // - offset;
      } else {
	// column known, use the calculation in colStartPx
	//   do the left and right columns separately to round the same way
	w = Math.max(
	      Math.round(((element.posxcols + element.widthcols) * (page.columnwidth + page.gutterwidth)) * page.pmToPx)
              - Math.round((element.posxcols * (page.columnwidth + page.gutterwidth)) * page.pmToPx)	// width like colStartPx
              - page.gutterwidthpx		// do not use the gutter
              - 2*page.boxindentpx		// indent on both sides
              - 2,				// border on both sides
              0);
      }

      // Handle the width of ads up against the right side of the page
      //if(this.x + this.widthcols - 1 == page.numCols) { w++; }
    }
    else
    {
      var offset = this.getPage().gutterWidthPx(0);

      // My size in columns times the column width minus the offset in pixels plus 1 pixel per column wide I am (for column borders)
      w = page.pagModToPx(this.sizex) - offset;

      if(!SCS_PM.EFFICIENCY_MODE)
      {
        var colNum = this.getPage().findColumnNum(this.posx+this.sizex);
        var colNode = this.getPage().getColumnNode(colNum, true, zone);

        // If my right edge (left + width + 2 for borders) is going to be 
        // beyond the right edge of my ending column then set my width so 
        // I line up the right edge properly.
        if( (this.leftPx() + w + 2) > (this.getPage().totalColWidthPx(colNum) + colNode.offsetWidth) )
        {
          w = this.getPage().totalColWidthPx(colNum) + colNode.offsetWidth - this.leftPx() - offset;
          //w = this.getPage().totalColWidthPx(colNum) - this.getPage().gutterWidthPx(colNum) + colNode.offsetWidth - this.leftPx();
        }
      }
    }

    this.pmToPxChanged = false;
    this.widthpx = w;
    return w; 
  },

  /*
    Get my height in pixels.  No need to do rounding here because we 
    dont have gutter widths to worry about
  */
  "heightPx" : function()
  {
    if(this.useCachedValue(this.heightpx)) { return this.heightpx; }

    // Subtract 3 so there is a little space between ads, 
    // we will also move the top down by 1 in topPx()
    var p=this.getPage();
    var h=p.pagModToPx(this.sizey)-2; // 2 for the top and bottom borders
    if (p.pagModToPx(this.sizey + this.posy) + 1 >= p.heightPx()) h-=2; // keep from hitting bottom
    if (p.pagModToPx(this.posy) <= 1) h--; // account for raising the top
    if (h < 0) h = 0;
    return h;
  },

  /*
    Get my left edge in pixels.  Recalculation is done here also, and will
    line my left edge up with the left edge of the column I start in.
    This is needed to avoid rounding issues.
  */
  "leftPx" : function()
  {
    if(this.useCachedValue(this.leftpx)) { return this.leftpx; }
    
    var page = this.getPage();

    // Find out our supposed left edge, and also what column 
    // we fall in according to PagMod units

    var e = this.manager.elements[this.elementid];
    var left;
    var n = isUndefinedOrNull;
    var cols = 0;
    if ( !n(e.posxcols) && ( e.posxcols > 0 ) ) {
      cols = e.posxcols;
    } else {
      cols = page.findColumnNum( this.posx );
    }
      
    var colPlusGutt = page.columnwidth + page.gutterwidth;

    left = page.borderwidthpx + Math.round( cols * colPlusGutt * page.pmToPx ) + page.boxindentpx;

    return left;
  },

  /*
    Get my top in pixels.
  */
  "topPx" : function()
  {
    if(this.useCachedValue(this.toppx)) { return this.toppx; }

    // If we measure from the bottom of the page...
    //return this.getPage().heightPx() - 
    //       this.getPage().pagModToPx(this.posy) - 
    //       this.getPage().pagModToPx(this.sizey);
   
    // If we measure from the top 
    // +1 actually moves the div down 1 px
    var p=this.getPage();
    var y=p.pagModToPx(this.posy);
    return y + 1 + ((y <= 1)? 1: 0);
  },

  /*
    Get my unique identifier.  If a boxnum is not specified, use a timestamp,
    and then save it off for further reference if needed.
  */
  "getId": function()
  {
    return SCS_PM.BOX_ID_PREFIX + this.boxnum;
  },

  "hasImage": function() {
    return ( this.manager.elements[this.elementid].showimage &&
             strip( this.manager.elements[this.elementid].imagesrc ) !== "" )
  },

  "showImageForBox": function() {
    return ( this.manager.showImages && this.hasImage() );
  },

  /*
    Set the element style based on the type of ad or block it is
  */
  "addElementClasses" : function(node)
  {
    var elem = this.manager.elements[this.elementid];
    if ( ( trim( elem.rendfilename ) != "" ) ||
         ( ( !isUndefinedOrNull( elem.cssboxcolor ) ) &&
           ( !isUndefinedOrNull( elem.cssfontcolor ) ) &&
           ( elem.cssboxcolor.length == 2 ) &&
           ( elem.cssfontcolor.length == 2 ) ) ) {
      var obj = this.manager.getColorObj(elem);
      if ( !this.showImageForBox() ) {
        setStyle( node, { "background": obj.box,
                          "color" : obj.text } );
      }
    }
    return true;
  },

  "addDescriptiveText" : function(boxDiv)
  {
    var span = SPAN();
    // Append descriptive text fields line by line
    for(var i = 0; i < 10; i++)
    {
      var txt = this.manager.elements[this.elementid]["desctext"+i];
      appendVariableSizeTextString(span, txt, this.widthPx());
    }
    
    /*
      MBB - potential method for increasing efficiency:
        getDOMOnlyWidth consumes 11% of the time to draw pages.  What if we
        instead only called it once, with a string of 10 'w' characters, to 
        determine the max width of a character in this user browser and font.
        Then, we could just multiply the length of each string of text by this
        character width and know the max? withdh of the resulting SPAN, and 
        avoid having to append a SPAN to the body, get it's width, and then 
        remove it, as getDOMOnly Width does...
    */

    if( !SCS_PM.EFFICIENCY_MODE &&
        getDOMOnlyHeight(span) < this.heightPx() &&
        getDOMOnlyWidth(span) < this.widthPx() )
    {
      // Let's see if we have room to make it a little bigger    
      setStyle(span, {'font-size':'1.5em'});
      if(getDOMOnlyHeight(span) > this.heightPx() ||
         getDOMOnlyWidth(span) > this.widthPx())
        { setStyle(span, {'font-size' : '1em' }); }
    }

    appendChildNodes(boxDiv, span);
  },

  /*
    Return a box node to be appended as a child node of the page node.  It 
    will be aboslutely positioned and the left and top styles will be 
    set appropriately to display it on the page.
    scs_box adds a 1-pixel border.
  */
  "getBoxNode": function()
  {
    var boxDiv = DIV( { "id"    : this.getId(),
                        "class" : "scs_box",
                        "style": "width: "  + this.widthPx()  + "px;" +
                                 "height: " + this.heightPx() + "px;" +
                                 "left: "   + this.leftPx()   + "px;" +
                                 "top: "    + this.topPx()    + "px;" },
                      null );

    if ( this.showImageForBox() ) {
      appendChildNodes( boxDiv,
                        IMG( { 'src'   : this.manager.elements[this.elementid].imagesrc,  
                               'alt'   : 'Ad Image',
                               'style' : 'width:'  + this.widthPx()  + 'px;' +
                                         'height:' + this.heightPx() + 'px;' }, null) );
    }
    else {
      if (!this.manager.showImages) {
        this.addDescriptiveText( boxDiv );
      }
      this.addElementClasses( boxDiv );
    }

    SCS_PM.attachOverlib(boxDiv, this.manager.elements[this.elementid].boxtip);
    this.manager.attachClickEvent(boxDiv, this);

    return boxDiv;
  },

  /*
    Append a vertical rule node as a child node of the page node.
    will be aboslutely positioned and the left and top styles will be 
    set appropriately to display it on the page.
    These nodes write the background color over lines for gutters.
  */
  "appendRuleNode": function(div, id, page, col, starty, endy)
  {
    var startpx = page.pagModToPx(starty) + ((starty <= 0)? 1: 0) - ((starty >= page.pageheight)? 1: 0);

    var height = page.pagModToPx(endy) + 1 + ((endy <= 0)? 1: 0) - startpx;

    var gutteroffset = Math.floor((page.gutterwidthpx - page.gutterlinepx) / 2);
    var leftpx = page.colStartPx(col+1) - page.gutterlinepx - gutteroffset;

    // for debugging, change scs_column to scs_box to make the border visible

    if (height > 0) {
      var boxDiv = DIV( { "id"    : id + "-R-" + col,
                          "class" : "scs_no_rule",
                          "style": "width: "  + page.gutterlinepx	+ "px;" +
                                   "height: " + height			+ "px;" +
                                   "left: "   + leftpx			+ "px;" +
                                   "top: "    + startpx			+ "px;"
                        },
                        null );

      appendChildNodes(div, boxDiv);
    }
  }
}

function scs_err(msg)
{
  log(msg);
  throw msg;
}

function appendVariableSizeTextString(node, txt, nodeWidth)
{
  var n = isUndefinedOrNull;
  nodeWidth = n(nodeWidth) ? getDOMOnlyWidth(node) : nodeWidth;
  if(!isUndefinedOrNull(txt) && trim(txt) != "")
  {
    txt = trim(txt);

    var txtSpan = SPAN(null, trim(txt));

    if( !SCS_PM.EFFICIENCY_MODE && 
        getDOMOnlyWidth(txtSpan) > (nodeWidth*0.9) ) // Multiply by 90% to avoid 
                                                     // rounding/inherent padding
      { setStyle(txtSpan, {'font-size' : "0.7em" });  }

    appendChildNodes(node, txtSpan, BR());

/* This is a bit too inefficient...just check 1em and 0.7em */
/*
    // x10 to allow for -- operation and then divide by 10
    var size = 10.0; 
    var done = false;
    
    // Decrease the size until it fits, or gets to <= 0.5em
    while(!done && size > 7 && nodeWidth != 0)
    {
      if(getDOMOnlyWidth(txtSpan) > nodeWidth)
        { done = true; }
      
      setStyle(txtSpan, {'font-size' : (--size)/10 + "em" }); 
    }
    appendChildNodes(node, txtSpan, BR());
*/
  }
}

function logToPage(s)
{
  appendChildNodes(document.body, SPAN(s), BR());
}

/*
  Given the JSON 'PagModJSON' object, return an object to pass to 
  a PageManager constructor that contains pages, boxes, elements, 
  webpages, and webboxes objects
*/
function readPagModJSONObject(obj)
{
  return { 'pages'          : obj.Pages,
           'boxes'          : obj.Boxes,
           'elements'       : obj.Elements,
           'webPages'       : obj.WebPages,
           'webBoxes'       : obj.WebBoxes };
}
